import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useBag } from '@/components/feature/bag/BagContext';

export const siteLinks = [
  { label: 'Shop', to: '/shop' },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const { count, openBag } = useBag();
  return (
    <>
      <nav className="relative flex items-center justify-between px-4 md:px-10 h-14 md:h-16 text-[12px] md:text-[13px] tracking-wide">
        <div className="hidden md:flex gap-8">
          {siteLinks.map((l) => (
            <Link key={l.label} to={l.to} className="whitespace-nowrap cursor-pointer hover:opacity-50 transition-opacity">{l.label}</Link>
          ))}
        </div>
        <Link to="/" className="ff-serif italic text-base md:hidden cursor-pointer">F&amp;F</Link>
        <Link to="/" className="hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap ff-serif italic text-[15px] cursor-pointer">Floral studio, est. 2019</Link>
        <div className="flex items-center gap-4 md:gap-8">
          <button type="button" onClick={openBag} className="whitespace-nowrap cursor-pointer hover:opacity-50 transition-opacity">Bag ({count})</button>
          <button type="button" aria-label="Menu" aria-expanded={open} onClick={() => setOpen(!open)} className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer whitespace-nowrap">
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </nav>
      {open && (
        <div className="md:hidden relative flex flex-col gap-4 px-4 pb-6 text-sm border-b border-black/10">
          {siteLinks.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="cursor-pointer">{l.label}</Link>
          ))}
        </div>
      )}
    </>
  );
}